import React from 'react'

const About = () => {
  return (
    <section className="section about-section">
     <h1 className="section-title">about us</h1>
     <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse placeat quia dolorum expedita maiores quisquam, harum eaque quidem dicta voluptatibus earum voluptates debitis provident asperiores modi consequuntur ea possimus sapiente illum itaque deserunt! Reprehenderit ullam beatae ipsa iste odit, deserunt expedita .</p>
    </section>
  )
}

export default About
